import React, { useLayoutEffect, useRef, useState } from 'react';

import { Box } from '@mui/material';

/** Screen and isolated subscription renderer lay out the same 1600px report before scaling. */
export default function LuxPlusReportCanvas({ enabled, children }: { enabled: boolean; children: React.ReactNode }) {
  const host = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  useLayoutEffect(() => {
    if (!enabled || !host.current) return;
    const element = host.current;
    const resize = () => setScale(Math.min(1, Math.max(0.1, element.clientWidth / 1600)));
    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(element);
    return () => observer.disconnect();
  }, [enabled]);
  if (!enabled) return children;
  return (
    <Box ref={host} sx={{ width: '100%', minWidth: 0, overflowX: 'auto' }}>
      <Box data-lens-report-canvas="" sx={{ width: 1600, minWidth: 1600, zoom: scale, mx: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
}
